import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";

import NavContext from "./NavContext";

interface INavProps {
  handleNavigation: () => void;
  children: React.ReactNode;
}

function NavProvider({ handleNavigation, children }: INavProps) {
  const [navigationConfig, setNavigationConfig] = useState({
    handleNavigation, // This function handles the shrinking of content when nav expands or collapses
    isShown: false,
    expanded: false,
    isMobile: false,
    isRequestFormV2Page: false,
    isRequestFormV2ReviewMode: false,
    isRequestPopupOpen: false,
    navWidth: 0,
    settingNavWidth: 0,
  });
  const navCtx = useMemo(() => ({ navigationConfig, setNavigationConfig }), [navigationConfig]);

  return <NavContext.Provider value={navCtx}>{children}</NavContext.Provider>;
}

NavProvider.propTypes = {
  handleNavigation: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default NavProvider;
